import { EnvoiSyntheseTleMode, PreferencesEnvoiSyntheseTleExpert } from "../apis/monsisra/generated";

const getModeEnvoiSyntheseTle = (pref?: PreferencesEnvoiSyntheseTleExpert | null): EnvoiSyntheseTleMode => {
	if (!pref) return EnvoiSyntheseTleMode.TO_EXPERT_SOLLICITE;
	switch (pref.modeEnvoiMss) {
		case EnvoiSyntheseTleMode.TO_EXPERT_FINAL:
		case EnvoiSyntheseTleMode.TO_EXPERT_SOLLICITE:
		case EnvoiSyntheseTleMode.TO_TIERCE:
		case EnvoiSyntheseTleMode.NE_PAS_ENVOYER:
			return pref.modeEnvoiMss;
		default:
			return EnvoiSyntheseTleMode.TO_EXPERT_SOLLICITE;
	}
};

const getLabelFromMode = (mode: EnvoiSyntheseTleMode) => {
	switch (mode) {
		case EnvoiSyntheseTleMode.NE_PAS_ENVOYER:
			return "Ne pas envoyer automatiquement la synthèse en courrier MSS";
		case EnvoiSyntheseTleMode.TO_EXPERT_FINAL:
			return "Envoyer la synthèse à l'adresse MSS de l'expert final";
		case EnvoiSyntheseTleMode.TO_EXPERT_SOLLICITE:
			return "Envoyer la synthèse à l'adresse MSS de l'expert sollicité";
		case EnvoiSyntheseTleMode.TO_TIERCE:
			return "Envoyer la synthèse à une adresse MSS tierce :";
		default:
			return "";
	}
};

export { getModeEnvoiSyntheseTle, getLabelFromMode };
